import React, { useEffect, useState } from "react";
import { getMembers, memberActivation,memberDeactivation } from "../../../../api/apiServices";
import UserRoles from "../../../../hooks/userRoles";
import useAuth from "../../../../hooks/useAuth";
import jwt_decode from "jwt-decode";
import toast, { Toaster } from "react-hot-toast";
import PhoneInput from "react-phone-input-2";


const MemberActivationManagement = () => {
	const { auth } = useAuth();
	const decoded = auth?.accessToken
		? jwt_decode(auth.accessToken)
		: undefined;

	const role = decoded?.UserInfo?.role || "";

	const [search, setSearch] = useState(false);
	const [members, setMembers] = useState({});
	const [member, setMember] = useState({});
	const [country, setCountry] = useState("gh");

	const [searchMember, setSearchMember] = useState({
		pf_number: "",
		mobile_number: "",
		first_name: "",
		last_name: "",
	});

	useEffect(() => {
		getMembers().then(res =>setMembers(res))
	}, [])
	
	// const { data: members } = useQuery("members", getMembers);

	const handleMobileNumber = (value, countryObj, e, formattedValue) => {
		const name = e.target.name;
		setSearchMember((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handleOnChange = (e) => {
		const name = e.target.name;
		const value = e.target.value;
		setSearchMember((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	
	const handleDeactivate = async (id, email, mobile_number) => {
		const deactivateData = {
			id: id,
			email: email,
			mobile_number: mobile_number,
		};
		await memberDeactivation(deactivateData).then((res) => {
			if (res.success) {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
				setSearch(false);
				setSearchMember({
					pf_number: "",
					mobile_number: "233",
					first_name: "",
					last_name: "",
				});
                setMember(null);
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
                setSearch(true);
                setMember(null);
            }
		});
	};
	const handleActivate = async (id, email, mobile_number) => {
		const activateData = {
			id: id,
			email: email,
			mobile_number: mobile_number,
		};
		await memberActivation(activateData).then((res) => {
			if (res.success) {
                toast.success(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
				setSearch(false);
				setSearchMember({
					pf_number: "",
					mobile_number: "233",
					first_name: "",
					last_name: "",
				});
                setMember(null);
            } else {
                toast.error(res.message, {
                    duration: 5000,
                    className: "toast-message",
                });
                setSearch(true);
                setMember(null);
            }
		});
	};

	const handleCancel = () => {
		setSearchMember({
			pf_number: "",
			mobile_number: "233",
			first_name: "",
			last_name: "",
		});
		setCountry("gh");
		setSearch(false);
	};

	const handleSearch = async (e) => {
		e.preventDefault();
		if (members?.length > 0) {			
			if (role === UserRoles.SuperAdmin || role === UserRoles.SystemAdmin) {
				const memberPfNumber = searchMember.pf_number;
				const memberMobileNumber = searchMember.mobile_number;
				const memberFirstname = searchMember.first_name;
				const memberLastname = searchMember.last_name;
	
				const findUser = members?.find(
					(member) =>
						member.pf_number === memberPfNumber ||
						member.mobile_number === memberMobileNumber ||
						member.first_name === memberFirstname ||
						member.last_name === memberLastname
				);
	
				if (findUser) {
					setSearch(true);
					setMember(findUser);
				} else {
					setSearch(false);
				}
			} else {
				toast.error(
					"You are not authorized to perform this function. Contact the System Administrator",
					{
						duration: 3000,
						className: "toast-message",
					}
				);
				return false;
			}
		}
	};

	const searchContent = (
		<form>
			<div className="form-group row">
				<div className="col-sm-3">
					<input
						type="text"
						style={{
							width: "100%",
							height: 40,
							fontSize: 16,
							textTransform: "uppercase",
							borderRadius: 5,
						}}
						placeholder="PF Number"
						name="pf_number"
						onChange={handleOnChange}
						className="form-control"
					/>
				</div>
				<div className="col-sm-3">
					<PhoneInput
						inputStyle={{
							fontSize: 16,
							width: "100%",
							height: 40,
						}}
						country={country}
						countryCodeEditable={false}
						enableSearch={true}
						enableClickOutside={false}
						value={searchMember.mobile_number}
						inputProps={{
							name: "mobile_number",
							autoFocus: true,
						}}
						onChange={(value, countryObj, e, formattedValue) =>
							handleMobileNumber(
								value,
								countryObj,
								e,
								formattedValue
							)
						}
					/>
				</div>
				<div className="col-sm-2">
					<input
						className="form-control"
						type="text"
						placeholder="FirstName"
						style={{
							width: "100%",
							height: 40,
							fontSize: 16,
							textTransform: "uppercase",
							borderRadius: 5,
						}}
						name="first_name"
						onChange={handleOnChange}
					/>
				</div>
				<div className="col-sm-2">
					<input
						className="form-control"
						type="text"
						placeholder="LastName"
						style={{
							width: "100%",
							height: 40,
							fontSize: 16,
							textTransform: "uppercase",
							borderRadius: 5,
						}}
						name="last_name"
						onChange={handleOnChange}
					/>
				</div>
				<div className="col-sm-2">
					<button
						type="button"
						onClick={handleSearch}
						className="btn btn-success btn-block"
					>
						Search Member
					</button>
				</div>
			</div>
		</form>
	);

	const content = (
		<div className="table-responsive lg">
			<table className="table table-borderless table-hover table-striped">
				<thead className="align">
					<tr>
						<th scope="col">Member ID</th>
						<th scope="col">PF Number</th>
						<th scope="col">Full Name</th>
						<th scope="col">Region</th>
						<th scope="col">Mobile Number</th>
						<th scope="col">Email</th>
						<th scope="col" style={{ textAlign: "center" }}>Action</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{member?.id}</td>
						<td>{member?.pf_number}</td>
						<td style={{ whiteSpace: "nowrap" }}>
							{member?.first_name +
								" " +
								member?.middle_name +
								" " +
								member?.last_name}
						</td>
						<td style={{ whiteSpace: "nowrap" }}>
							{member?.region}
						</td>
						<td style={{ whiteSpace: "nowrap" }}>
							{member?.mobile_number}
						</td>
						<td>{member?.email}</td>
						<td style={{ whiteSpace: "nowrap" }}>
							<div
								style={{
									display: "inline-block",
									whiteSpace: "nowrap",
								}}
							>
								<button
									className="btn"
									onClick={() => handleActivate(
										member?.id,
										member?.email,
										member?.mobile_number
									)}

								>
									<i className="fa fa-edit"></i> Activate
								</button>
							
								<button
									className="btn"
									onClick={() => handleDeactivate(
										member?.id,
										member?.email,
										member?.mobile_number
									)}

								>
									<i className="fa fa-edit"></i> Deactivate
								</button>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>Member Activation Management </h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											{searchContent}
										</h4>
									</div>
								</div>
							</div>
							{search && (
								<>
									<div className="panel-body">{content}</div>
									<div className="panel-footer">
										<div className="search-group">
											<button
												type="submit"
												className="btn btn-danger "
												onClick={handleCancel}
											>
												{" "}
												<i className="fa fa-search"></i>{" "}
												Cancel
											</button>
										</div>
									</div>
								</>
							)}
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default MemberActivationManagement;
